import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { IActivity } from '@shared/interfaces/activity.interface';
import { IAPIArrayData } from '@shared/interfaces/api.interface';
import { IFilter } from '@shared/interfaces/filter.interface';
import { IPaginable } from '@shared/interfaces/paginable.interface';
import { Activity } from '@shared/models/activity.model';
import { EMPTY, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CandidatesActivitiesService implements IPaginable {
  private readonly ENDPOINT_V3: string = String(
    `${environment.ENDPOINTS.BACK_END.V3}/candidates`
  );

  constructor(private readonly _http: HttpClient) {}

  public getPage(
    page: number,
    onGetRawData?: (data: IAPIArrayData) => void,
    filter?: IFilter
  ): Observable<IActivity[]> {
    let params: HttpParams = new HttpParams();
    params = params.set('page[number]', String(page));

    const id = filter?.value;

    if (!Boolean(id)) {
      return EMPTY;
    }

    return this._http
      .get<IAPIArrayData>(`${this.ENDPOINT_V3}/${id}/activities`, {
        params
      })
      .pipe(
        tap((data: IAPIArrayData) => onGetRawData && onGetRawData(data)),
        map((res: IAPIArrayData) => Activity.fromAPIArray(res))
      );
  }
}
